import { FileUploaderDropContainer, FileUploaderItem } from '@carbon/react';
import { FileAtomState } from 'lib/atoms/file-atom';
import styles from './document-fields.module.scss';

interface DocumentUploadFieldProps {
  heading?: string;
  helperText: string;
  labelText: string;
  accept: string[];
  upload: FileAtomState;
  onAddFiles: (
    event: React.SyntheticEvent<HTMLElement>,
    payload: { addedFiles: File[] }
  ) => void;
  onDelete: () => void;
  disabled: boolean;
}

// Shared file-upload field: an optional heading, helper text, the Carbon drop
// container, and the selected-file row. Upload state is owned by the caller.
export const DocumentUploadField = ({
  heading,
  helperText,
  labelText,
  accept,
  upload,
  onAddFiles,
  onDelete,
  disabled,
}: DocumentUploadFieldProps) => {
  const isUploadComplete = upload.status === 'complete';

  return (
    <>
      {heading && <h4 className={styles.sectionTitle}>{heading}</h4>}
      <p className={styles.helperText}>{helperText}</p>
      <div className={styles.uploadWrapper}>
        <FileUploaderDropContainer
          labelText={labelText}
          accept={accept}
          onAddFiles={onAddFiles}
          disabled={disabled}
        />
        {upload.name && (
          <FileUploaderItem
            name={upload.name}
            status={
              isUploadComplete
                ? 'edit'
                : upload.status === 'error'
                  ? 'edit'
                  : upload.status
            }
            invalid={upload.invalid || upload.status === 'error'}
            errorBody={upload.error}
            onDelete={onDelete}
          />
        )}
      </div>
    </>
  );
};
